import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PaymentResult({ mode }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState(mode === "cancel" ? "cancelled" : "checking");
  const [kind, setKind] = useState(null);

  useEffect(() => {
    if (mode === "cancel") return;
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setKind(data.kind);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* keep trying */ }
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [mode]);

  const paid = status === "paid";
  const ok = paid;

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        {status === "checking" ? (
          <>
            <div className="w-12 h-12 border-2 border-navy border-t-transparent rounded-full animate-spin mx-auto" />
            <p className="font-mono text-xs uppercase tracking-widest text-charcoal/60 mt-6">Confirming your gift...</p>
          </>
        ) : (
          <>
            {ok ? <CheckCircle2 size={56} className="text-navy mx-auto" strokeWidth={1.3} /> : <XCircle size={56} className="text-rust mx-auto" strokeWidth={1.3} />}
            <h1 className="font-serif text-4xl tracking-tight mt-6">
              {ok ? (kind === "ticket" ? "You're going!" : "Thank you!") : status === "cancelled" ? "Checkout cancelled" : "Still processing"}
            </h1>
            <p className="font-sans text-charcoal/60 mt-3">
              {ok ? (kind === "ticket" ? "Your ticket is confirmed. See you there." : "Your generous gift has been received. God bless you.")
                : status === "cancelled" ? "No charge was made. You can try again anytime."
                : "Your payment is being processed. Check your portal shortly."}
            </p>
            <div className="flex gap-3 justify-center mt-8">
              <Link to="/supporter" className="bg-charcoal text-bone px-8 py-3 font-mono text-xs uppercase tracking-widest hover:bg-navy transition-colors">Back to Portal</Link>
              <Link to="/events" className="border border-charcoal/30 px-8 py-3 font-mono text-xs uppercase tracking-widest hover:bg-charcoal hover:text-bone transition-colors">Events</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
